/* unplugin-vue-components disabled */import script from "./paypalFeeCalculator.vue?vue&type=script&setup=true&lang=js"
export * from "./paypalFeeCalculator.vue?vue&type=script&setup=true&lang=js"

import "./paypalFeeCalculator.vue?vue&type=style&index=0&id=df4bb38e&lang=css"

const __exports__ = script;

export default __exports__